import React, { useState } from 'react';
import { Settings } from 'lucide-react';

const DevModeSelector = ({ currentRole, onRoleChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const roles = [
    { value: 'advisor', label: 'Advisor' },
    { value: 'admin', label: 'Admin' },
  ];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-1.5 bg-yellow-400 text-gray-900 rounded-lg hover:bg-yellow-300 transition-colors text-sm font-medium"
      >
        <Settings className="w-4 h-4" />
        <span>DEV: {roles.find(r => r.value === currentRole)?.label || 'Not Logged In'}</span>
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="py-2">
            <div className="px-4 py-2 text-xs text-gray-500 font-semibold border-b border-gray-200">
              SWITCH ROLE
            </div>
            {roles.map((role) => (
              <button
                key={role.value}
                onClick={() => {
                  onRoleChange(role.value);
                  setIsOpen(false);
                }}
                className={`block w-full text-left px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-800 transition-colors ${
                  currentRole === role.value ? 'bg-emerald-50 text-emerald-800 font-medium' : ''
                }`}
              >
                {role.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DevModeSelector;
